import React from 'react';
import { Box, Container, Divider } from '@drivekyte/web-components';
import { useMedia } from '@drivekyte/ui';
import WPTypography from '@/components/typography';
import PostItem from '@/pages/company/components/post-item';
import { Post } from '@/pages/company/types';

const styles = {
  flexContainer: {
    display: 'flex',
    flexWrap: 'wrap' as 'wrap',
    alignContent: 'center',
  },
};

type MorePostsProps = {
  moreBlogPostsHeader: string;
  posts: Post[];
};

const MorePosts = ({ moreBlogPostsHeader, posts }: MorePostsProps) => {
  const media = useMedia();

  if (!posts || posts.length === 0) {
    return null;
  }

  return (
    <Container>
      <Divider />

      <Box marginTop="xLarge" marginBottom="medium">
        <WPTypography
          variant="p"
          color="quaternary"
          fontSize={17}
          lineHeight={24}
          fontWeight={600}
        >
          {moreBlogPostsHeader}
        </WPTypography>
      </Box>

      <div style={styles.flexContainer}>
        {posts.map((post) => (
          <div key={post.id} style={{ width: media.xs ? '100%' : '33%' }}>
            <PostItem
              slug={post.attributes.slug}
              title={post.attributes.title}
              author={post.attributes.author.name}
              date={post.attributes.date}
              image={post.attributes.headlineImage}
            />
          </div>
        ))}
      </div>
    </Container>
  );
};

export default MorePosts;
